import React, { useEffect } from 'react';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/component/message.module.scss';
//store
import useComnStore from 'src/webapp/stores/comn.store';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function SubmitMessage() {
    const { message, setMessage } = useComnStore();//메세지 결과처리

    useEffect(() => {
        if(message.type === 0 && message.message.length <= 0) { return; }

        setTimeout(function () { setMessage({type:0, message:''}) }, 3000);
      }, [message]);

	return (
        <>
        {message.type !== 0 && message.message.length > 0 ?
            <Element tag={`div`} className={styles.messageContainer}>
                <Element tag={`div`}>
                    <Element tag={`div`}>
                        {message.type === 1 ? <Element tag={`small`} className={styles.correct}><FontAwesomeIcon icon="fa-light fa-check" /></Element> : null}
                        {message.type === 2 ? <Element tag={`small`} className={styles.error}><FontAwesomeIcon icon="fa-light fa-circle-exclamation" /></Element> : null}
                        {message.type === 3 ? <Element tag={`small`} className={styles.error}><FontAwesomeIcon icon="fa-light fa-circle-exclamation" /></Element> : null}
                        <Element tag={`p`}>{message.message}</Element>
                    </Element>
                </Element>
            </Element>
        : null}
        </>
	);
}